import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { PSP_API } from '../../constants/central-api';
import { applicationWWWXRLEncodedBodyBuilder } from '../../utils/body-builder';
import { submitLogToBugsnag } from '../log';

export default async function add_psp_api_call(
  selectedPSP: string,
  pspInputValues: any,
  selected_payment_methods: string[]
) {
  try {
    const accessToken = store.getState().auth.authorization.accessToken;
    const isWhiteLabel = store.getState().UI?.isWhiteLabel;
    const shop_slug = store.getState().user.company.shop_slug;
    let sellerToken: string;
    if (isWhiteLabel) {
      sellerToken = accessToken?.currentWhiteLabelSellerToken;
    } else {
      sellerToken = accessToken?.sellerToken;
    }

    const requestInfo: RequestInfo = {
      url: PSP_API(shop_slug),
      method: 'POST',
      body: applicationWWWXRLEncodedBodyBuilder({
        psp_service_slug: selectedPSP,
        payment_details: JSON.stringify(pspInputValues),
        payment_methods: JSON.stringify(selected_payment_methods),
      }),
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/x-www-form-urlencoded',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'ONBOARDING_PSP_CONNECTION';
    const customMsg = 'Connection Successful.';

    const res: any = await asyncHandler(requestInfo, actionType, customMsg);

    const response = res.data;

    if (res.actionType === actionType && response.success === true) {
      return true;
    } else {
      return false;
    }
  } catch (exception) {
    console.log('Error during authentication request');
    submitLogToBugsnag('error', `${exception}`);
    return false;
  }
}
